import { render, staticRenderFns } from "./UnlockForButton.vue?vue&type=template&id=60e8b7ac&"
import script from "./UnlockForButton.vue?vue&type=script&lang=ts&"
export * from "./UnlockForButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports